import httpClient, { getLanguageHeader } from 'src/http-client';

export async function get(id: string, language = 'ja') {
  const response = await httpClient.get<Record<string, string>>(`/translations/${id}`, {
    headers: getLanguageHeader(language),
  });
  return response.data;
}
